export default {
   BASE_URL: "https://brushi-api.rajaranicouture.co.in",  // publish
  // BASE_URL: "https://localhost:7253",
}
